// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"RatingCard_blockContainer__XfWOB"};